import { MockCard } from '../../components/mockups/MockUI'
import { MockTable } from '../../components/mockups/MockTable'
import { MockBadge } from '../../components/mockups/MockBadge'

export function NotificationsBell() {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-2">
          Колокольчик в шапке
        </h2>
        <p className="text-sm text-gray-600 dark:text-gray-400">
          В правом верхнем углу — иконка колокольчика. Цифра рядом — количество непрочитанных
          уведомлений. Клик открывает выпадающую ленту последних событий, в подвале списка — ссылка
          «Смотреть все» на страницу <span className="font-mono text-xs">/notifications</span>.
        </p>
      </div>
      <MockCard>
        <div className="text-sm text-gray-600 dark:text-gray-400 space-y-2">
          <div className="font-medium text-gray-800 dark:text-gray-200">Поведение:</div>
          <ul className="list-disc list-inside space-y-1">
            <li>
              Счётчик обновляется в реальном времени через WebSocket — новое уведомление сразу видно
            </li>
            <li>
              Клик на запись помечает её прочитанной и переводит на связанную сущность (заявку,
              квоту, комментарий)
            </li>
            <li>Кнопка «Прочитать все» обнуляет счётчик одним нажатием</li>
          </ul>
        </div>
      </MockCard>
    </div>
  )
}

export function NotificationsFeed() {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-2">
          Лента уведомлений
        </h2>
        <p className="text-sm text-gray-600 dark:text-gray-400">
          Полная история уведомлений — страница{' '}
          <span className="font-mono text-xs">/notifications</span>. Непрочитанные подсвечены, у
          каждой записи указан тип события, время и автор.
        </p>
      </div>
      <MockCard>
        <div className="text-sm text-gray-600 dark:text-gray-400 space-y-2">
          <div className="font-medium text-gray-800 dark:text-gray-200">Что в записи:</div>
          <ul className="list-disc list-inside space-y-1">
            <li>
              Заголовок и тело — кратко описано событие («Закупщик добавил квоту по STM32F103»)
            </li>
            <li>Связанная заявка / позиция / квота — клик открывает её и подсвечивает строку</li>
            <li>Время — относительное («5 мин назад»), на hover — точная дата</li>
            <li>Иконка автора — кто сделал действие, вызвавшее уведомление</li>
          </ul>
        </div>
      </MockCard>
    </div>
  )
}

export function NotificationsTypes() {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-2">
          Типы событий
        </h2>
        <p className="text-sm text-gray-600 dark:text-gray-400">
          Уведомления приходят только по существенным событиям, без шумного техспама.
        </p>
      </div>
      <MockTable
        caption="4 типа уведомлений"
        columns={[{ header: 'Событие' }, { header: 'Кому' }, { header: 'Когда' }]}
        rows={[
          [
            <MockBadge color="blue">Новая квота</MockBadge>,
            'Менеджеру заявки',
            'Закупщик создал одиночную квоту по позиции',
          ],
          [
            <MockBadge color="purple">Импорт квот</MockBadge>,
            'Менеджеру заявки',
            'Закупщик загрузил Excel-ответ — одно агрегированное уведомление, не N штук',
          ],
          [
            <MockBadge color="green">Закупка завершена</MockBadge>,
            'Менеджеру заявки',
            'Закупщик отметил «закупка по заявке завершена»',
          ],
          [
            <MockBadge color="orange">Комментарий к квоте</MockBadge>,
            'Автору квоты или менеджеру',
            'Кто-то прокомментировал конкретную квоту',
          ],
        ]}
      />
      <MockCard>
        <div className="text-sm text-gray-600 dark:text-gray-400">
          ADMIN получает уведомления только по тем заявкам, где он сам менеджер. Иначе админ тонул
          бы в чужих переписках по всей системе.
        </div>
      </MockCard>
    </div>
  )
}

export function NotificationsMentions() {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-2">
          @-упоминания в комментариях
        </h2>
        <p className="text-sm text-gray-600 dark:text-gray-400">
          В любом поле для комментария (к заявке, позиции или квоте) наберите символ{' '}
          <span className="font-mono">@</span> — появится выпадающий список доступных пользователей.
          Стрелки/Enter выбирают, в текст вставляется <span className="font-mono">@Имя </span>.
        </p>
      </div>
      <MockCard>
        <div className="text-sm text-gray-600 dark:text-gray-400 space-y-2">
          <div className="font-medium text-gray-800 dark:text-gray-200">
            Кто появляется в выпадайке:
          </div>
          <ul className="list-disc list-inside space-y-1">
            <li>Все ADMIN</li>
            <li>Менеджер заявки</li>
            <li>РОП — если его города пересекаются с городом менеджера</li>
            <li>Закупщики и РОЗ — по тем же городам</li>
          </ul>
          <p className="mt-2">
            Закупщик может @упомянуть другого закупщика — например, чтобы переадресовать вопрос.
            Упомянутый получит уведомление с прямой ссылкой на комментарий.
          </p>
        </div>
      </MockCard>
    </div>
  )
}

export function NotificationsNews() {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-2">
          Лента новостей
        </h2>
        <p className="text-sm text-gray-600 dark:text-gray-400">
          Раздел «Лента новостей» — внутренние объявления компании. Страница{' '}
          <span className="font-mono text-xs">/news</span>: читают все сотрудники, публикуют ADMIN и
          руководители подразделений — РОП, РОЗ, бухгалтер, логист и руководитель склада.
        </p>
      </div>
      <MockCard>
        <div className="text-sm text-gray-600 dark:text-gray-400 space-y-2">
          <div className="font-medium text-gray-800 dark:text-gray-200">Как устроено:</div>
          <ul className="list-disc list-inside space-y-1">
            <li>
              Форма «Опубликовать новость» вверху страницы (видна только тем, кто публикует) — поля
              «Заголовок» и «Текст новости», кнопка «Опубликовать». Переносы строк сохраняются
            </li>
            <li>Автор может править и удалять свои посты, ADMIN — любые</li>
            <li>У каждого поста — автор и точная дата публикации</li>
            <li>Новые посты появляются у всех в реальном времени, без обновления страницы</li>
          </ul>
        </div>
      </MockCard>
      <MockCard>
        <div className="text-sm text-gray-600 dark:text-gray-400 space-y-2">
          <div className="font-medium text-gray-800 dark:text-gray-200">Виджет на дашборде:</div>
          <p>
            Блок «Лента новостей» на дашборде показывает последние 4 новости, ссылка «Все новости →»
            ведёт в полный раздел. Клик по записи открывает ленту и прокручивает к этому посту с
            подсветкой.
          </p>
        </div>
      </MockCard>
    </div>
  )
}
